module.exports = __webpack_public_path__ + "img/icon11.db33afb6.png";